// extracted by mini-css-extract-plugin
export default {"title":"_3714aa5f69","bld":"eedd6a644e"};